import { render, staticRenderFns } from "./AuthSignup.vue?vue&type=template&id=3a5772ff&scoped=true&"
import script from "./AuthSignup.vue?vue&type=script&lang=js&"
export * from "./AuthSignup.vue?vue&type=script&lang=js&"
import style0 from "./AuthSignup.vue?vue&type=style&index=0&id=3a5772ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5772ff",
  null
  
)

export default component.exports